<div class="search-wrapper" [class.active]="isActive">
  <div class="input-holder">
    <input type="text" [(ngModel)]="searchTerm" placeholder="Type to search" class="search-input" (keyup.enter)="onClickSearch()">
    <button class="search-icon" (click)="onClickSearch()"><span></span></button>
  </div>
  <button class="close" (click)="onClickClose()"></button>
</div>